export default __webpack_public_path__ + "static/media/receiptLong.ed4355a7.svg";